module.exports = __webpack_public_path__ + "img/banner-home@2x.f1bc734b.jpg";